import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/acp-mobile-sdkdocs/acp-mobile-sdkdocs/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
import Tabs from './tabs/migration.md';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TabsBlock = makeShortcode("TabsBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "migrating-to-aepcore-reference"
    }}>{`Migrating to AEPCore reference`}</h1>
    <p>{`This document is a reference comparison of ACPCore (2.x) APIs against their equivalent APIs in AEPCore (3.x).`}</p>
    <h2 {...{
      "id": "primary-classes"
    }}>{`Primary `}<inlineCode parentName="h2">{`Classes`}</inlineCode></h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Swift)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`AEP 3.x (Objective-C)`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`ACP 2.x (Objective-C)`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Primary Class`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`MobileCore`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`AEPMobileCore`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ACPCore`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Enum`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`LogLevel`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`AEPLogLevel`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`ACPMobileLogLevel`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "core-extension-apis"
    }}>{`Core extension APIs`}</h2>
    <h3 {...{
      "id": "trackaction"
    }}>{`trackAction`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=track-action" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=track-action" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=track-action" mdxType="Tabs" />
    <h3 {...{
      "id": "trackstate"
    }}>{`trackState`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=track-state" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=track-state" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=track-state" mdxType="Tabs" />
    <h3 {...{
      "id": "collectpii"
    }}>{`collectPii`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=collect-pii" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=collect-pii" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=collect-pii" mdxType="Tabs" />
    <h3 {...{
      "id": "collectlaunchinfo"
    }}>{`collectLaunchInfo`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=collect-launch-info" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=collect-launch-info" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=collect-launch-info" mdxType="Tabs" />
    <h3 {...{
      "id": "getsdkidentities"
    }}>{`getSdkIdentities`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=get-sdk-identities" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=get-sdk-identities" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=get-sdk-identities" mdxType="Tabs" />
    <h3 {...{
      "id": "setloglevel"
    }}>{`setLogLevel`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=set-log-level" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=set-log-level" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=set-log-level" mdxType="Tabs" />
    <h3 {...{
      "id": "registerurlhandler"
    }}>{`registerURLHandler`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=register-url-handler" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=register-url-handler" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=register-url-handler" mdxType="Tabs" />
    <h3 {...{
      "id": "setappgroup"
    }}>{`setAppGroup`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=set-app-group" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=set-app-group" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=set-app-group" mdxType="Tabs" />
    <h3 {...{
      "id": "configurewithappid"
    }}>{`configureWithAppId`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=configure-with-app-id" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=configure-with-app-id" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=configure-with-app-id" mdxType="Tabs" />
    <h3 {...{
      "id": "updateconfiguration"
    }}>{`updateConfiguration`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=update-configuration" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=update-configuration" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=update-configuration" mdxType="Tabs" />
    <h3 {...{
      "id": "configurewithfileinpath"
    }}>{`configureWithFileInPath`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=configure-with-file-in-path" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=configure-with-file-in-path" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=configure-with-file-in-path" mdxType="Tabs" />
    <h3 {...{
      "id": "extensionversion"
    }}>{`extensionVersion`}</h3>
    <TabsBlock orientation="horizontal" slots="heading, content" repeat="3" mdxType="TabsBlock" />
    <p>{`AEP 3.x (Swift)`}</p>
    <Tabs query="platform=aep-swift&api=extension-version" mdxType="Tabs" />
    <p>{`AEP 3.x (Objective-C)`}</p>
    <Tabs query="platform=aep-objc&api=extension-version" mdxType="Tabs" />
    <p>{`ACP 2.x (Objective-C)`}</p>
    <Tabs query="platform=acp-objc&api=extension-version" mdxType="Tabs" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      